// AUTO-GENERATED GraphQL Builder for Vendor
import * as Builders from '../';
export class VendorBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  name(){ return this.add('name'); }
  code(){ return this.add('code'); }
  serviceCategoryId(){ return this.add('serviceCategoryId'); }
  stateId(){ return this.add('stateId'); }
  cityId(){ return this.add('cityId'); }
  addressLine(){ return this.add('addressLine'); }
  gpsLat(){ return this.add('gpsLat'); }
  gpsLng(){ return this.add('gpsLng'); }
  about(){ return this.add('about'); }
  eventsHandled(){ return this.add('eventsHandled'); }
  isReseller(){ return this.add('isReseller'); }
  isVerified(){ return this.add('isVerified'); }
  ssmNo(){ return this.add('ssmNo'); }
  bankId(){ return this.add('bankId'); }
  bankAccountName(){ return this.add('bankAccountName'); }
  bankAccountNo(){ return this.add('bankAccountNo'); }
  status(){ return this.add('status'); }
  phone(){ return this.add('phone'); }
  feeRate(){ return this.add('feeRate'); }
  defaultDepositPct(){ return this.add('defaultDepositPct'); }
  suspendReason(){ return this.add('suspendReason'); }
  email(){ return this.add('email'); }
  logoUrl(){ return this.add('logoUrl'); }
  bannerUrl(){ return this.add('bannerUrl'); }
  notifBooking(){ return this.add('notifBooking'); }
  notifPartner(){ return this.add('notifPartner'); }
  notifHold(){ return this.add('notifHold'); }
  notifPayout(){ return this.add('notifPayout'); }
  isApproved(){ return this.add('isApproved'); }
  reuploadToken(){ return this.add('reuploadToken'); }
  reuploadTokenExpiry(){ return this.add('reuploadTokenExpiry'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  bank(b?:(q:Builders.BankBuilder)=>void){
    if(this.depth>=5||this.v.has('bank'))return this;
    this.v.add('bank');
    const n=new Builders.BankBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bank { ${inner} }`);
    return this;
  }

  city(b?:(q:Builders.CityBuilder)=>void){
    if(this.depth>=5||this.v.has('city'))return this;
    this.v.add('city');
    const n=new Builders.CityBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`city { ${inner} }`);
    return this;
  }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  serviceCategory(b?:(q:Builders.ServiceCategoryBuilder)=>void){
    if(this.depth>=5||this.v.has('serviceCategory'))return this;
    this.v.add('serviceCategory');
    const n=new Builders.ServiceCategoryBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`serviceCategory { ${inner} }`);
    return this;
  }

  state(b?:(q:Builders.StateBuilder)=>void){
    if(this.depth>=5||this.v.has('state'))return this;
    this.v.add('state');
    const n=new Builders.StateBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`state { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }

  blacklistList(b?:(q:Builders.BlacklistBuilder)=>void){
    if(this.depth>=5||this.v.has('blacklistList'))return this;
    this.v.add('blacklistList');
    const n=new Builders.BlacklistBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`blacklistList { ${inner} }`);
    return this;
  }

  bookingList(b?:(q:Builders.BookingBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingList'))return this;
    this.v.add('bookingList');
    const n=new Builders.BookingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingList { ${inner} }`);
    return this;
  }

  bookingFeeRateList(b?:(q:Builders.BookingFeeRateBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingFeeRateList'))return this;
    this.v.add('bookingFeeRateList');
    const n=new Builders.BookingFeeRateBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingFeeRateList { ${inner} }`);
    return this;
  }

  bookingPackageList(b?:(q:Builders.BookingPackageBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingPackageList'))return this;
    this.v.add('bookingPackageList');
    const n=new Builders.BookingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPackageList { ${inner} }`);
    return this;
  }

  bookingPartnerChangeByFromVendorList(b?:(q:Builders.BookingPartnerChangeBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingPartnerChangeByFromVendorList'))return this;
    this.v.add('bookingPartnerChangeByFromVendorList');
    const n=new Builders.BookingPartnerChangeBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPartnerChangeByFromVendorList { ${inner} }`);
    return this;
  }

  bookingPartnerChangeByToVendorList(b?:(q:Builders.BookingPartnerChangeBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingPartnerChangeByToVendorList'))return this;
    this.v.add('bookingPartnerChangeByToVendorList');
    const n=new Builders.BookingPartnerChangeBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPartnerChangeByToVendorList { ${inner} }`);
    return this;
  }

  earlyReleaseList(b?:(q:Builders.EarlyReleaseBuilder)=>void){
    if(this.depth>=5||this.v.has('earlyReleaseList'))return this;
    this.v.add('earlyReleaseList');
    const n=new Builders.EarlyReleaseBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`earlyReleaseList { ${inner} }`);
    return this;
  }

  ledgerEntryList(b?:(q:Builders.LedgerEntryBuilder)=>void){
    if(this.depth>=5||this.v.has('ledgerEntryList'))return this;
    this.v.add('ledgerEntryList');
    const n=new Builders.LedgerEntryBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`ledgerEntryList { ${inner} }`);
    return this;
  }

  notificationList(b?:(q:Builders.NotificationBuilder)=>void){
    if(this.depth>=5||this.v.has('notificationList'))return this;
    this.v.add('notificationList');
    const n=new Builders.NotificationBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`notificationList { ${inner} }`);
    return this;
  }

  offeringList(b?:(q:Builders.OfferingBuilder)=>void){
    if(this.depth>=5||this.v.has('offeringList'))return this;
    this.v.add('offeringList');
    const n=new Builders.OfferingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringList { ${inner} }`);
    return this;
  }

  partnerApprovalList(b?:(q:Builders.PartnerApprovalBuilder)=>void){
    if(this.depth>=5||this.v.has('partnerApprovalList'))return this;
    this.v.add('partnerApprovalList');
    const n=new Builders.PartnerApprovalBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`partnerApprovalList { ${inner} }`);
    return this;
  }

  partnershipByPartnerVendorList(b?:(q:Builders.PartnershipBuilder)=>void){
    if(this.depth>=5||this.v.has('partnershipByPartnerVendorList'))return this;
    this.v.add('partnershipByPartnerVendorList');
    const n=new Builders.PartnershipBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`partnershipByPartnerVendorList { ${inner} }`);
    return this;
  }

  partnershipByResellerVendorList(b?:(q:Builders.PartnershipBuilder)=>void){
    if(this.depth>=5||this.v.has('partnershipByResellerVendorList'))return this;
    this.v.add('partnershipByResellerVendorList');
    const n=new Builders.PartnershipBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`partnershipByResellerVendorList { ${inner} }`);
    return this;
  }

  resaleList(b?:(q:Builders.ResaleBuilder)=>void){
    if(this.depth>=5||this.v.has('resaleList'))return this;
    this.v.add('resaleList');
    const n=new Builders.ResaleBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`resaleList { ${inner} }`);
    return this;
  }

  resaleTermByPartnerVendorList(b?:(q:Builders.ResaleTermBuilder)=>void){
    if(this.depth>=5||this.v.has('resaleTermByPartnerVendorList'))return this;
    this.v.add('resaleTermByPartnerVendorList');
    const n=new Builders.ResaleTermBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`resaleTermByPartnerVendorList { ${inner} }`);
    return this;
  }

  resaleTermByResellerVendorList(b?:(q:Builders.ResaleTermBuilder)=>void){
    if(this.depth>=5||this.v.has('resaleTermByResellerVendorList'))return this;
    this.v.add('resaleTermByResellerVendorList');
    const n=new Builders.ResaleTermBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`resaleTermByResellerVendorList { ${inner} }`);
    return this;
  }

  reviewList(b?:(q:Builders.ReviewBuilder)=>void){
    if(this.depth>=5||this.v.has('reviewList'))return this;
    this.v.add('reviewList');
    const n=new Builders.ReviewBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`reviewList { ${inner} }`);
    return this;
  }

  vendorCoverageAreaList(b?:(q:Builders.VendorCoverageAreaBuilder)=>void){
    if(this.depth>=5||this.v.has('vendorCoverageAreaList'))return this;
    this.v.add('vendorCoverageAreaList');
    const n=new Builders.VendorCoverageAreaBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`vendorCoverageAreaList { ${inner} }`);
    return this;
  }

  vendorUserList(b?:(q:Builders.VendorUserBuilder)=>void){
    if(this.depth>=5||this.v.has('vendorUserList'))return this;
    this.v.add('vendorUserList');
    const n=new Builders.VendorUserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`vendorUserList { ${inner} }`);
    return this;
  }

  vendorVerificationList(b?:(q:Builders.VendorVerificationBuilder)=>void){
    if(this.depth>=5||this.v.has('vendorVerificationList'))return this;
    this.v.add('vendorVerificationList');
    const n=new Builders.VendorVerificationBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`vendorVerificationList { ${inner} }`);
    return this;
  }

  reverseBookingFeeRate(b?:(q:Builders.BookingFeeRateBuilder)=>void){
    const n=new Builders.BookingFeeRateBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingFeeRateList { ${inner} }`);
    return this;
  }

  reverseBookingPackage(b?:(q:Builders.BookingPackageBuilder)=>void){
    const n=new Builders.BookingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPackageList { ${inner} }`);
    return this;
  }

  reverseEarlyRelease(b?:(q:Builders.EarlyReleaseBuilder)=>void){
    const n=new Builders.EarlyReleaseBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`earlyReleaseList { ${inner} }`);
    return this;
  }

  reverseLedgerEntry(b?:(q:Builders.LedgerEntryBuilder)=>void){
    const n=new Builders.LedgerEntryBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`ledgerEntryList { ${inner} }`);
    return this;
  }

  reverseLoginResult(b?:(q:Builders.LoginResultBuilder)=>void){
    const n=new Builders.LoginResultBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`loginResultList { ${inner} }`);
    return this;
  }

  reverseNotification(b?:(q:Builders.NotificationBuilder)=>void){
    const n=new Builders.NotificationBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`notificationList { ${inner} }`);
    return this;
  }

  reverseOffering(b?:(q:Builders.OfferingBuilder)=>void){
    const n=new Builders.OfferingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringList { ${inner} }`);
    return this;
  }

  reverseReview(b?:(q:Builders.ReviewBuilder)=>void){
    const n=new Builders.ReviewBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`reviewList { ${inner} }`);
    return this;
  }

  reverseVendorCoverageArea(b?:(q:Builders.VendorCoverageAreaBuilder)=>void){
    const n=new Builders.VendorCoverageAreaBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`vendorCoverageAreaList { ${inner} }`);
    return this;
  }

  reverseVendorUser(b?:(q:Builders.VendorUserBuilder)=>void){
    const n=new Builders.VendorUserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`vendorUserList { ${inner} }`);
    return this;
  }

  reverseVendorVerification(b?:(q:Builders.VendorVerificationBuilder)=>void){
    const n=new Builders.VendorVerificationBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`vendorVerificationList { ${inner} }`);
    return this;
  }
}
